import download from 'downloadjs';
import API, { defaultHeaders, IRI } from '@/api';

const fetchExport = (payload, tag = false) => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;

  if (tag) {
      var endpoint = 'export-codes-tag'
    } else {
      var endpoint = 'export-codes'
    }

  return fetch(`${API}/panel/course/${IRI.course}${payload}/${endpoint}`, {headers})
    .then(res => {
      if (res.status !== 200) {
        throw Error('Invalid download status');
      }

      return res.blob();
    })
    .then(blob => download(blob, `code-export.csv`, 'text/csv'))
    .catch(e => console.error(e))
  ;
};

export default fetchExport;
